import { render } from "./TiposUbicaciones.vue?vue&type=template&id=4ba1e7fe"
import script from "./TiposUbicaciones.vue?vue&type=script&lang=js"
export * from "./TiposUbicaciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__